/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A replacement for a game's branding. Every field is replaced, so one left out is cleared.
 * @export
 * @interface GameBrandingUpdateRequest
 */
export interface GameBrandingUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof GameBrandingUpdateRequest
     */
    fontColorPrimary?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GameBrandingUpdateRequest
     */
    brandColorPrimary?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GameBrandingUpdateRequest
     */
    specialBallColor?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GameBrandingUpdateRequest
     */
    logoUrl?: string | null;
}

/**
 * Check if a given object implements the GameBrandingUpdateRequest interface.
 */
export function instanceOfGameBrandingUpdateRequest(value: object): value is GameBrandingUpdateRequest {
    return true;
}

export function GameBrandingUpdateRequestFromJSON(json: any): GameBrandingUpdateRequest {
    return GameBrandingUpdateRequestFromJSONTyped(json, false);
}

export function GameBrandingUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GameBrandingUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'fontColorPrimary': json['fontColorPrimary'] == null ? undefined : json['fontColorPrimary'],
        'brandColorPrimary': json['brandColorPrimary'] == null ? undefined : json['brandColorPrimary'],
        'specialBallColor': json['specialBallColor'] == null ? undefined : json['specialBallColor'],
        'logoUrl': json['logoUrl'] == null ? undefined : json['logoUrl'],
    };
}

export function GameBrandingUpdateRequestToJSON(value?: GameBrandingUpdateRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'fontColorPrimary': value['fontColorPrimary'],
        'brandColorPrimary': value['brandColorPrimary'],
        'specialBallColor': value['specialBallColor'],
        'logoUrl': value['logoUrl'],
    };
}

